module.exports = __webpack_public_path__ + "static/media/mihai.cd86426f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/whereby/mihai.mp4
// module id = 329
// module chunks = 0